/* unplugin-vue-components disabled */import script from "./LockFileView.vue?vue&type=script&setup=true&lang=js"
export * from "./LockFileView.vue?vue&type=script&setup=true&lang=js"

import "./LockFileView.vue?vue&type=style&index=0&id=24448653&scoped=true&lang=css"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24448653"]])

export default __exports__